import React, { useState, useEffect,useRef } from 'react';
import Axios from "axios";
import { GetAttemptedInterviewsByEmployer, MoveFileFromAzureBlob } from '../apiconstants/constants';
import { Link, useNavigate } from 'react-router-dom';
import ReactPaginate from "react-paginate";
import nodataimg from "../assets/images/Nodata.jpg";
import Tooltip from 'react-bootstrap/Tooltip';
import OverlayTrigger from 'react-bootstrap/OverlayTrigger';
import LoadingSpinner from '../helpers/loadingspinner';
import ConsultantLayout from '../commonlayouts/consultantlayout';
import Swal from 'sweetalert2';
import {Modal, Button } from 'react-bootstrap';


function strip_html_tags(str) {
  if ((str === null) || (str === 'undefined' || str === undefined))
    return false;
  else
    str = str.toString();
  str = str.replace(/<[^>]*>/g, '');
  return substring_str(str.replace('&nbsp;', '').replace('.&nbsp;', ''));
}

function substring_str(str) {
  if ((str === null) || (str === ' ' || str === undefined))
    return "";
  else
    str = str.toString();
  return str.substring(0, 50) + "...";
}
const ListOfSavedVideos = () => {
  const [offset, setOffset] = useState(0);
  const [data, setData] = useState([]);
  const [perPage] = useState(6);
  const [pageCount, setPageCount] = useState(0);
  const [candidateData, setCandidateData] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [searchTerm, setSearchTerm] = useState("");
  const [selectedItems, setSelectedItems] = useState([]);
  const [selectAll, setSelectAll] = useState(false);
  const [rating, setRating] = useState([
    { ratingID: "1", ratingName: "1 - Not-Considerable" },
    { ratingID: "2", ratingName: "2 - Average Candidate" },
    { ratingID: "3", ratingName: "3 - Considerable Candidate" },
    { ratingID: "4", ratingName: "4 - Preferable Candidate" },
    { ratingID: "5", ratingName: "5 - Expert Candidate" },
]);

const [filteredItems, setFilteredItems] = useState([]);
const [showModal, setShowModal] = useState(false);
const [currentVideoUrl, setCurrentVideoUrl] = useState('');
const [candidateFile, setCandidateFile] = useState(null);
const [showMoveModal, setShowMoveModal] = useState(false);
const [candidateGuid, setCandidateGuid] = useState(null);
const videoRef = useRef(null);
const navigate = useNavigate();

  const handlePageClick = (e) => {
    const selectedPage = e.selected;
    setOffset(selectedPage * perPage);
  };
  let Guid = "";
  const guid = localStorage.getItem("guid");
  const employerGuid = localStorage.getItem("employerGuid");
  const roleID = localStorage.getItem("roleID");
const token = localStorage.getItem("jwtToken");
  if (roleID == 3) {
    Guid = employerGuid;
  } else {
    Guid = guid;
  }
  const GetCandidateList = () => {
    setIsLoading(true);
  
    const GetapiUrl = `${GetAttemptedInterviewsByEmployer.APIURL}/${Guid}`;
  
   Axios.get(GetapiUrl, {
  headers: {
    "Authorization": `Bearer ${token}`,
    
  }
})
      .then((result) => {
        setIsLoading(false);
        setCandidateData(result.data.filter((x) => (x.isActive == false) &&(x.isDelete == false) &&(x.isMoved == false)));
      })
      .catch((error) => {
        console.log("Error" + error);
      });
  };
  

  const handleFileMove = (url,guid) => {
  
    const filename = url?.split('/')?.pop();
    console.log(filename)
    setCandidateFile(url);
    setCandidateGuid(guid);
    setShowMoveModal(true)
  };
  const handleConfirmMovingFile = async () => {
      setShowMoveModal(false)
      setIsLoading(true)
await Axios.post(
  `${MoveFileFromAzureBlob.APIURL}?blobFileName=${candidateFile?.split('/')?.pop()}&guid=${candidateGuid}`,
  {},  // body is empty because you're only using query params
  {
    headers: {
      Authorization: `Bearer ${token}`
    }
  }
)       .then((result) => 
         {
          setIsLoading(false)
           if((result.data=='Failed to download file from Azure Blob Storage.')||(result.data=='Failed to update database with new Video URL.')  ){
             Swal.fire({
               position: 'center',
               icon: 'error',
               title: 'Failed to move video from Azure Blob Storage.',
               showConfirmButton: false,
               timer: 2000,
             })
//navigate("/Employer/ListSavedVideos")
           }
         
           else{
            Swal.fire({
              position: 'center',
              icon: 'success',
              title: 'Moved succesfully',
              showConfirmButton: false,
              timer: 2000,
            })
            setCandidateData(prevData => prevData.filter(candidate => candidate.guiID !== candidateGuid));
           }
        //  setCandidateData(prevData => prevData.filter(candidate => candidate.guiID !== candidateGuid));
         setIsLoading(false);
         setShowModal(false);
 
       })
       .catch((error) => {
        setIsLoading(false)
         console.log("Error" + error);
       });
     }
 
 
 
 const handleCancel = () => {
   setShowModal(false);
 };

 const handleCancelMoveModal = () => {
  setShowMoveModal(false);
};
 
  const getRatingName = (ratingID) => {
    const ratingItem = rating.find(r => r.ratingID == ratingID);
    return ratingItem ? ratingItem.ratingName : "Unknown Rating";
  }

  const handleVideoClick = (videoURL) => {
    setCurrentVideoUrl(videoURL);
    setShowModal(true);
  };

  const handleClose = () => {
    setShowModal(false);
    setCurrentVideoUrl('');
  };

  const handleForward = () => {
    if (videoRef.current) {
      videoRef.current.currentTime += 10; // Forward by 10 seconds
    }
  };

  const handleRewind = () => {
    if (videoRef.current) {
      videoRef.current.currentTime -= 10; // Rewind by 10 seconds
    }
  };
  useEffect(() => {
    GetCandidateList();
  }, []);

  useEffect(() => {
    const filteredData = candidateData.filter(candidate =>
      candidate?.name.toLowerCase().includes(searchTerm.toLowerCase()) ||
      candidate?.jobRole.toLowerCase().includes(searchTerm.toLowerCase())
    );
  setFilteredItems(filteredData)
    const slice = filteredData.slice(offset, offset + perPage);
    const items = slice.map((data) => {
      const isSelected = selectedItems.some(item => item.guiID === data.guiID);

      return (
      
        <div className="col-sm-12 col-md-6 col-xl-4 col-lg-4 pb-3" key={data.guiID}>
        <div className="card" style={{ background: "#f8f8f8", border: '1px solid #00a7ac26', maxHeight: 520, height: 500, borderRadius: 20 }}>
          {/* <div className='card-header' style={{ background: "none", minHeight: 170 }}> */}
          <div className='card-header' style={{ background: "none", minHeight: 170 }}>
            <div className='row'>
              <div className='col-8'>
                <OverlayTrigger placement="bottom" overlay={(props) => (<Tooltip id="tooltip" {...props}>Name</Tooltip>)}>
                  <p className="card-title jb-head" style={{ color: "#00a7ac", fontSize: 24 }}><b>{data.name}</b></p>
                </OverlayTrigger>
                <OverlayTrigger placement="bottom" overlay={(props) => (<Tooltip id="tooltip" {...props}>Job Role</Tooltip>)}>
                  <h5 style={{ fontSize: 18 }}>{data.jobRole}</h5>
                </OverlayTrigger>
              </div>
            </div>
          </div>
          <div className="card-body">
            <OverlayTrigger placement="bottom" overlay={(props) => (<Tooltip id="tooltip" {...props}><span className="tooltip2">Email</span></Tooltip>)}>
              <p style={{ fontSize: 14, textAlign: 'justify' }}><i style={{ fontSize: 14, color: "#00a7ac", marginRight: 10 }} className="fa fa-envelope" aria-hidden="true"></i> {data.email}  </p>
            </OverlayTrigger>
            <OverlayTrigger placement="bottom" overlay={(props) => (<Tooltip id="tooltip" {...props}><span className="tooltip2">Mobile Number</span></Tooltip>)}>
              <p style={{ fontSize: 14, textAlign: 'justify' }}><i style={{ fontSize: 14, color: "#00a7ac", marginRight: 10 }} className="fa fa-phone" aria-hidden="true"></i> {data.mobileNumber}  </p>
            </OverlayTrigger>
            {/* <OverlayTrigger placement="bottom" overlay={(props) => (<Tooltip id="tooltip" {...props}>Test Date</Tooltip>)}>
              <p style={{ fontSize: 14 }}><i style={{ fontSize: 14, color: "#00a7ac", marginRight: 10 }} className="fas fa-calendar" aria-hidden="true"></i> {formatDate(data.startDate)} to {formatDate(data.endDate)}</p>
            </OverlayTrigger> */}
            {data.rating !== null && data.rating !== "null" &&
              <OverlayTrigger placement="bottom" overlay={(props) => (<Tooltip id="tooltip" {...
                props}>Rating</Tooltip>)}>
                <p style={{ fontSize: 14 }}><i style={{ fontSize: 14, color: "#00a7ac", marginRight: 10 }} className="fas fa-star" aria-hidden="true"></i> {getRatingName(data.rating)}</p>
                </OverlayTrigger>}
                {data.comments !== null && data.comments !== "null" &&
                <OverlayTrigger placement="bottom" overlay={(props) => (<Tooltip id="tooltip" {...props}>Comments</Tooltip>)}>
                <p style={{ fontSize: 14 }}><i style={{ fontSize: 14, color: "#00a7ac", marginRight: 10 }} className="fas fa-comment" aria-hidden="true"></i> {strip_html_tags(data.comments)}</p>
                </OverlayTrigger>}
                <OverlayTrigger placement="bottom" overlay={(props) => (<Tooltip id="tooltip" {...props}>Video</Tooltip>)}>
                <p style={{ fontSize: 18 }}>
                <i style={{ fontSize: 14, color: "#00a7ac", marginRight: 10 }} className="fas fa-video" aria-hidden="true"></i> <a href="#!" onClick={() => handleVideoClick(data.videoURL)}>Click to View Video</a>
                </p>
                </OverlayTrigger>
              
                </div>
                {/* <div className='card-footer d-flex justify-content-center' style={{ background: "none" }}> */}
                <div className='card-footer d-flex justify-content-between' style={{ background: "none",maxHeight:160 }}>
              
              {/* <OverlayTrigger placement="bottom" overlay={(props) => (<Tooltip id="tooltip" {...props}> Move</Tooltip>)}>
              <button style={{ background: "none", border: "none" }} onClick={()=>handleFileMove(data.videoURL,data.guiID)}><i className="fa fa-arrows-alt" aria-hidden="true" style={{ fontSize: 20, color: "#00a7ac" }}></i></button>
              </OverlayTrigger> */}
              <Link to={"/Employer/ViewSavedVideoCandidateDetails?guid=" + data.guiID}>
                <OverlayTrigger placement="bottom" overlay={(props) => (<Tooltip id="tooltip" {...props}> View</Tooltip>)}>
                <button style={{ background: "none", border: "none" }}><i className="fa fa-eye" aria-hidden="true" style={{ fontSize: 20, color: "#00a7ac",marginTop:4 }}></i></button>
                </OverlayTrigger>
                </Link>
              <OverlayTrigger placement="bottom" overlay={(props) => (<Tooltip id="tooltip" {...props}>Select</Tooltip>)}>

       <input
           type="checkbox"
           checked={isSelected}
           onChange={() => handleCheckboxChange(data)}
         />
         </OverlayTrigger>      
              </div>
                </div>
                </div>
      );
    });

    setData(items);
    setPageCount(Math.ceil(filteredData.length / perPage));
  }, [offset, searchTerm, candidateData, perPage, selectedItems]);

  const handleSearch = (e) => {
    setSearchTerm(e.target.value);
    setOffset(0);
  };

  const handleCheckboxChange = (item) => {
    const selectedIndex = selectedItems.findIndex(selectedItem => selectedItem.guiID === item.guiID);
  
    if (selectedIndex === -1) {
      setSelectedItems([...selectedItems, item]);
    } else {
      const updatedItems = selectedItems.filter(selectedItem => selectedItem.guiID !== item.guiID);
      setSelectedItems(updatedItems);
    }

  };
  

  const handleSelectAll = () => {
    if (selectAll) {
      setSelectedItems([]);
    } else {
      setSelectedItems(candidateData);
    }
    setSelectAll(!selectAll);
  };

  const handleForwardClick = () => {
    localStorage.setItem('selectedVideos', JSON.stringify(selectedItems));
    navigate('SelectedVideos');
  };

  return (
    <ConsultantLayout>
      <div className='container mt-3'>
        <div className="responsive-container" style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
          <h2 className="" style={{ color: "#00a7ac" }}>List of Saved Videos</h2>
          <div style={{ display: 'flex', alignItems: 'center' }}>
            <input
              id="searchvendor"
              type="text"
              placeholder="Search by Full Name or Job Role"
              className="form-control"
              value={searchTerm}
              onChange={handleSearch}
              style={{ marginRight: '10px' }}
            />
            <div style={{ marginRight: '10px' }}>
              <input
                type="checkbox"
                checked={selectAll}
                onChange={handleSelectAll}
              />
              <label style={{ marginLeft: '5px' }}>Select All</label>
            </div>
          
           

            
          </div>
        </div>
    { selectedItems.length>0&&   <div style={{ textAlign: 'right', marginTop: '10px' }}>
          <button className="btn btn-primary" onClick={handleForwardClick}>
            <i className="fa fa-arrow-right"></i> Click to Proceed
          </button>
        </div>}
        <hr />

        {/* { candidateData.length===0 || filteredItems.length === 0 &&  (
          <div className="pb-5 text-center">
            <img title='No Data' alt='no-data-img' className='no-data-img' src={nodataimg} style={{ height: 350 }} />
          </div>
        )}

        <div className="row mt-5 pb-3">
          {isLoading ? <center><LoadingSpinner /></center> : <> {data}</>}
        </div> */}
         {isLoading ? (
          <center><LoadingSpinner /></center>
        ) : (
          <>
            {candidateData.length > 0  && filteredItems.length > 0 ? (
              <div className="row mt-5 pb-3">
                {data}
              </div>
            ) : (
              <div className="pb-5 text-center">
                <img title='No Data' className='no-data-img' alt="no-data-img" src={nodataimg} style={{ height: 370 }} />
              </div>
            )}
          </>
        )}
        {
         candidateData.length > 0  && filteredItems.length > perPage &&
          <ReactPaginate
            previousLabel={"Prev"}
            nextLabel={"Next"}
            breakLabel={"..."}
            breakClassName={"break-me"}
            pageCount={pageCount}
            marginPagesDisplayed={2}
            pageRangeDisplayed={10}
            onPageChange={handlePageClick}
            containerClassName={"pagination"}
            subContainerClassName={"pages pagination"}
            activeClassName={"active"}
            disabledClassName={"disable-pagination-button"}
          />
        }
      </div>
      <Modal show={showModal} onHide={handleClose} size="lg" centered>
    <Modal.Header closeButton style={{ borderBottom: 'none' }}>
    </Modal.Header>
    <Modal.Body style={{ padding: 0, overflow: 'hidden' }}>
      {/* <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
      <video autoplay loop muted playsinline ref={videoRef} width="100%" height="90%" controls>
      <source src={currentVideoUrl} type="video/webm" />
          Your browser does not support the video tag.
        </video>
        <div style={{ marginTop: 10 }}>
          <OverlayTrigger placement="top" overlay={<Tooltip>Rewind 10sec</Tooltip>}>
            <button onClick={handleRewind} style={{ background: "none", border: "none", marginRight: 10 }}>
              <i className="fas fa-undo" style={{ fontSize: 20, color: "#00a7ac" }}></i>
            </button>
          </OverlayTrigger>
          <OverlayTrigger placement="top" overlay={<Tooltip>Forward 10sec</Tooltip>}>
            <button onClick={handleForward} style={{ background: "none", border: "none", marginRight: 10 }}>
              <i className="fas fa-redo" style={{ fontSize: 20, color: "#00a7ac" }}></i>
            </button>
          </OverlayTrigger>
          <OverlayTrigger placement="top" overlay={<Tooltip>Download Video</Tooltip>}>
            <a href={currentVideoUrl} download>
              <i className="fas fa-download" style={{ fontSize: 20, color: "#00a7ac" }}></i>
            </a>
          </OverlayTrigger>
        </div>
      </div> */}
      <div className="iframe-container">
        <iframe 
          src={currentVideoUrl} 
          sandbox="allow-scripts allow-same-origin" 
          className="responsive-iframe" 
          allow="autoplay"
        ></iframe>
      </div>
    </Modal.Body>
  </Modal>

  <Modal show={showMoveModal} style={{textAlign:"center"}} onHide={handleCancelMoveModal}>
        <Modal.Header closeButton>
          <Modal.Title style={{color:"#00a7ac"}}>Confirm Moving File </Modal.Title>
        </Modal.Header>
        <Modal.Body>Are you sure you want to move this file?</Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={handleCancelMoveModal}>No</Button>
          <Button variant="primary" onClick={handleConfirmMovingFile}>Yes</Button>
        </Modal.Footer>
      </Modal>
    </ConsultantLayout>
  );
}

export default ListOfSavedVideos;
